import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { scrollStore } from 'core/stores';
import { defaultTemplate } from 'core/hoc';

class ScrollToTopButtonTemplate extends Component {
  static propTypes = {
    scrollThreshold: PropTypes.number,
    className: PropTypes.string,
    style: PropTypes.object,
    title: PropTypes.string
  };

  static defaultProps = {
    scrollThreshold: 100,
    className: 'btn btn--scroll u-icon u-icon--lrg u-icon--scroll-to-top',
    title: 'Scroll to top'
  };

  handleScroll = () => {
    const { scrollThreshold } = this.props;
    const scrollableElement = document.querySelector('.layout__content');
    if (scrollableElement) {
      scrollStore.setIsVisible(scrollableElement.scrollTop > scrollThreshold);
    }
  };

  scrollToTop = () => {
    const scrollableElement = document.querySelector('.layout__content');
    if (scrollableElement) {
      scrollableElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  componentDidMount() {
    const scrollableElement = document.querySelector('.layout__content');
    if (scrollableElement) {
      scrollableElement.addEventListener('scroll', this.handleScroll);
      this.handleScroll();
    }
  }

  componentWillUnmount() {
    const scrollableElement = document.querySelector('.layout__content');
    if (scrollableElement) {
      scrollableElement.removeEventListener('scroll', this.handleScroll);
    }
  }

  render() {
    const { className, style, title } = this.props;

    if (!scrollStore.isVisible) return null;

    return (
      <button
        onClick={this.scrollToTop}
        className={className}
        style={style}
        title={title}
      />
    );
  }
}

export default defaultTemplate(ScrollToTopButtonTemplate);
